import * as React from "react";
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, DateTimePicker } from "@material-ui/pickers";

export interface MUIDateTimePickerProps {
  label: string;
  value: Date;
  onChange: (dueData: Date) => void;
}

const MUIDateTimePicker: React.FC<MUIDateTimePickerProps> = ({
  label,
  onChange,
  value,
}) => {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <DateTimePicker
        autoOk
        ampm={false}
        disableToolbar
        inputVariant="outlined"
        margin="normal"
        label={label}
        value={value}
        disablePast={true}
        onChange={onChange}
      />
    </MuiPickersUtilsProvider>
  );
};

export default MUIDateTimePicker;
